import { render, staticRenderFns } from "./SuperProjectList.vue?vue&type=template&id=c6956116&scoped=true&"
import script from "./SuperProjectList.vue?vue&type=script&lang=js&"
export * from "./SuperProjectList.vue?vue&type=script&lang=js&"
import style0 from "./SuperProjectList.vue?vue&type=style&index=0&id=c6956116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6956116",
  null
  
)

export default component.exports